<!--批量阅卷-->
<template>
	<div class="patch-content" v-loading="loading">
		<operateBar
			v-show="!isFullNav"
			@scalePage="scalePage"
			@lessenPage="lessenPage"
			:miniScaleState="miniScaleState"
			:studentId="studentNameList"
			@setDifficultPaper="setDifficultPaper"
			@setTypical="setTypical"
		/>
		<div class="content" v-if="picUrls.length > 1">
			<div v-for="(item, index) in patchList" v-show="index % picUrls.length === 0" :key="index" class="img-wrap" @click="addPatchScore(index)">
				<img :src="item.myInfo.canvasImg" />
				<div class="score-state" v-show="item.myInfo.state">
					<i class="iconfont iconduigou" v-show="selPatchMeans === 'add' && item.myInfo.type !== -2"></i>
					<i class="iconfont iconwrong" v-show="selPatchMeans === 'reduce' && item.myInfo.type !== -2"></i>
					<img src="../../../assets/image/difficult.jpg" class="difficult-img" v-show="item.myInfo.type === -2" alt="疑难卷" />
					<img src="../../../assets/image/typical.jpg" class="difficult-img" v-show="item.myInfo.type === 1" alt="典型卷" />
					<div class="score" v-show="item.myInfo.type !== -2">{{ score }}<i class="score-unit">分</i></div>
				</div>
			</div>
		</div>
		<div class="content" v-else>
			<div v-for="(item, index) in patchList" :key="index" class="img-wrap" @click="addPatchScore(index)">
				<img :src="item.myInfo.canvasImg" />
				<div class="score-state" v-show="item.myInfo.state">
					<i class="iconfont iconduigou" v-show="selPatchMeans === 'add' && item.myInfo.type !== -2"></i>
					<i class="iconfont iconwrong" v-show="selPatchMeans === 'reduce' && item.myInfo.type !== -2"></i>
					<img src="../../../assets/image/difficult.jpg" class="difficult-img" v-show="item.myInfo.type === -2" alt="疑难卷" />
					<img src="../../../assets/image/typical.jpg" class="handle-img" v-show="item.myInfo.type === 1" alt="典型卷" />
					<div class="score" v-show="item.myInfo.type !== -2">{{ score }}<i class="score-unit">分</i></div>
				</div>
			</div>
		</div>
		<puzzleDifficult
			v-if="puzzleDifficultState"
			v-model="puzzleDifficultState"
			@confirmPuzzleDiff="confirmPuzzleDiff"
			:paperType="paperType"
		></puzzleDifficult>
	</div>
</template>

<script>
import { combineImageByUrl } from '../utils/handle-img'
import { submitScore } from '../utils/help'
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
	name: 'patch-content',
	components: {
		operateBar: () => import('./operate-bar'),
		puzzleDifficult: () => import('./puzzle-difficult')
	},
	data() {
		return {
			//是否全屏
			isFullNav: false,
			//批量阅卷列表
			patchList: [],
			//query
			query: this.$route.query,
			// 显示状态
			selPatchMeans: 'add',
			//得分
			score: 0,
			//当前分数
			currentScore: 0,
			loading: false,
			//缩放
			miniScaleState: false,
			//批量阅卷数目
			patchNum: 1,
			cid: 0,
			//当前激活索引
			curActiveIndex: null,
			//激活列表
			curActiveIndexList: [],
			//批量疑难卷状态
			puzzleDifficultState: false,
			//批量类型
			puzzleDifficultType: null,
			// 试卷类型
			paperType: null,
			//学生列表
			studentNameList: '',
			// 图片
			picUrls: []
		}
	},
	created() {
		this.watchCurrentEmit()
	},
	methods: {
		...mapActions('examination/databases', ['set', 'get']),
		watchCurrentEmit() {
			this.eventBus.$on('isFullNav', cb => (this.isFullNav = cb))
			this.eventBus.$on('patchSubmitScore', () => {
				this.curActiveIndex = null
				this.curActiveIndexList = []
			})
			this.eventBus.$on('changePatchMeans', cb => {
				if (cb === 'add') this.score = this.currentScore
				if (cb === 'reduce') this.score = 0
				this.selPatchMeans = cb
				this.patchList.map(res => (res.myInfo.state = false))
			})
			this.eventBus.$on('setPatchNum', cb => {
				this.patchNum = cb
				this.patchList = []
				this.phoneMarkingList()
			})
			this.eventBus.$on('patchSubmitScore', () => this.patchSubmitScore())
		},
		// 获取列表
		phoneMarkingList() {
			const _this = this
			this.cid += 1
			const params = {
				examId: this.query.examId,
				examSubjectId: this.query.examSubjectId,
				paperTextTaskId: this.query.paperTextTaskId,
				markingTaskId: this.query.markingTaskId,
				type: this.query.type
			}
			const num = this.patchNum
			this.studentNameList = ''
			for (let i = 0; i < num; i++) {
				this.$post('marking/phoneMarking', params).then(res => {
					this.eventBus.$emit('examBaseInfo', res.data)
					this.eventBus.$emit('personProgress', {
						markingedCount: res.data.markingedCount,
						markingTaskNum: res.data.markingTaskNum,
						markingSum: res.data.markingSum,
						markingedSum: res.data.markingedSum,
						hardMarkingSum: res.data.hardMarkingSum,
						hardMarkingedSum: res.data.hardMarkingedSum
					})
					let resData = res.data
					this.studentNameList += res.data.studentId + ','
					if (this.cid === 1) this.score = res.data.textPaperScores[0].score
					this.currentScore = res.data.textPaperScores[0].score
					this.eventBus.$emit('patchCurrentScore', res.data.textPaperScores[0].score)
					this.picUrls = resData.urls
					combineImageByUrl(resData.urls, [], 1, false, function(val) {
						resData.myInfo = { canvasImg: val.img, state: false, type: null, puzzleContent: '' }
						_this.patchList.push(resData)
					})
					_this.loading = false
				})
			}
		},
		//打分
		addPatchScore(index) {
			this.$set(this.patchList[index].myInfo, 'state', !this.patchList[index].myInfo.state)
			this.curActiveIndex = index
			if (!this.curActiveIndexList.includes(index)) this.curActiveIndexList.push(index)
			if (!this.patchList[index].myInfo.state) {
				this.$set(this.patchList[index].myInfo, 'type', null)
				this.$delete(this.curActiveIndexList, this.curActiveIndexList.length - 1)
				this.curActiveIndex = this.curActiveIndexList[this.curActiveIndexList.length - 1]
			}
			this.$forceUpdate()
		},
		// 提交
		async patchSubmitScore() {
			this.loading = true
			const flag = await this.get({ dbName: 'database', path: `patchScoreMeans`, defaultValue: 'add', user: true })
			if ((this.selPatchMeans === 'add' && flag === 'add') || (this.selPatchMeans === 'add' && flag === 'reduce')) {
				this.handlePatchSubmitScore()
				return false
			}
			this.$confirm(`其余未设置分数，默认分数为${flag === 'add' ? '满' : '零'}分?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(() => {
				this.set({ dbName: 'database', path: `patchScoreMeans`, value: this.selPatchMeans, user: true })
				this.handlePatchSubmitScore()
			})
		},
		handlePatchSubmitScore() {
			this.patchList.forEach(res => {
				let score
				if (res.myInfo.state) {
					if (this.selPatchMeans === 'add') score = [res.textPaperScores[0].score]
					if (this.selPatchMeans === 'reduce') score = [0]
				} else {
					if (this.selPatchMeans === 'add') score = [0]
					if (this.selPatchMeans === 'reduce') score = [res.textPaperScores[0].score]
				}
				res.textPaperScores[0].getScore = score
				let type = this.query.type
				if (res.myInfo.type !== null) type = res.myInfo.type
				if (type === -2) res.textPaperScores[0].getScore = null
				let basicInfo = cloneDeep(res)
				basicInfo.examAnswerMarkingId = 0
				this.$delete(res, 'myInfo')
				submitScore(this, this.query, basicInfo.textPaperScores, basicInfo, {}, 1, type, false, false, basicInfo.myInfo.puzzleContent)
			})
			this.patchList = []
			this.phoneMarkingList()
		},
		//    放大图片
		scalePage() {
			this.operateScale(10)
		},
		//缩小图片
		lessenPage() {
			this.operateScale(0)
		},
		//设置缩放
		operateScale(expand) {
			const _this = this
			this.miniScaleState = !this.miniScaleState
			const patchList = cloneDeep(this.patchList)
			this.patchList = []
			patchList.forEach(res => {
				const params = {
					expand: expand,
					studentId: res.studentId,
					examId: _this.query.examId,
					examSubjectId: _this.query.examSubjectId,
					paperTextTaskId: _this.query.paperTextTaskId
				}
				_this.$post('marking/expandPaper', params).then(responce => {
					combineImageByUrl(responce.data, [], 1, false, function(val) {
						res.myInfo.canvasImg = val.img
					})
				})
			})
			this.patchList = patchList
		},

		// 确定 疑难卷 典型卷
		confirmPuzzleDiff(val) {
			this.puzzleDifficultState = false
			if (this.puzzleDifficultType === 'difficult') {
				this.$set(this.patchList[this.curActiveIndex].myInfo, 'type', -2)
			} else if (this.puzzleDifficultType === 'typical') {
				this.$set(this.patchList[this.curActiveIndex].myInfo, 'type', 1)
			}
			this.$set(this.patchList[this.curActiveIndex].myInfo, 'puzzleContent', val)
		},
		//     设置疑难卷
		setDifficultPaper() {
			if (this.curActiveIndex === null) {
				this.$message.error('请先阅卷')
				return false
			}
			this.paperType = -2
			const type = this.patchList[this.curActiveIndex].myInfo.type
			if (type === 1 || type === null) {
				this.puzzleDifficultState = true
				this.puzzleDifficultType = 'difficult'
			} else {
				this.$set(this.patchList[this.curActiveIndex].myInfo, 'type', null)
			}
		},
		//    设置典型卷
		setTypical() {
			if (this.curActiveIndex === null) {
				this.$message.error('请先阅卷')
				return false
			}
			this.paperType = 1
			const type = this.patchList[this.curActiveIndex].myInfo.type
			if (type === null || type === -2) {
				this.puzzleDifficultState = true
				this.puzzleDifficultType = 'typical'
			} else {
				this.$set(this.patchList[this.curActiveIndex].myInfo, 'type', null)
			}
		}
	}
}
</script>

<style scoped lang="less">
.patch-content {
	width: 100%;
	height: 97%;
	background: #cbeade;
	.content {
		max-height: calc(100% - 50px);
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		overflow: auto;
		.img-wrap {
			height: fit-content;
			max-width: calc(50% - 5px);
			margin-right: 5px;
			margin-bottom: 5px;
			position: relative;
			&:nth-child(2n) {
				margin-right: 0;
			}
			img {
				max-width: 100%;
				max-height: 100%;
			}
			.score-state {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				z-index: 1;
				background: rgba(0, 0, 0, 0.5);
			}
			.score {
				position: absolute;
				top: -10px;
				left: 10px;
				font-size: 70px;
				color: red;
			}
			.score-unit {
				font-size: 25px;
				font-style: normal;
			}
			.iconfont {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				font-size: 70px;
				color: red;
			}
			.handle-img {
				position: absolute;
				right: 20px;
				top: 15px;
				width: 80px;
				height: 80px;
				border-radius: 50%;
			}
			.difficult-img {
				position: absolute;
				right: 20px;
				top: 15px;
				width: 80px;
				height: 80px;
				border-radius: 50%;
			}
		}
	}
}
</style>
